import * as React from 'react';

const Search24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.102 16.162a8 8 0 1 1 1.06-1.06l5.368 5.368a.75.75 0 1 1-1.06 1.06zM16.5 10a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0"
  }
));
Search24.Size = 24;
Search24.Title = "Search";

export { Search24 as default };
